<div class="container">

	<div class="portalCard">

		<div class="rowScreenColPhone">

			<div class="aTitle">
				<mat-icon style="vertical-align: middle;">menu</mat-icon>
				<span>Berichtsjahrverwaltung</span>
			</div>

			<mat-spinner diameter=30 *ngIf="bLoading" />

			<button mat-raised-button color="primary"
				[disabled]="bLoading"
				(click)="showCreationDialog()"
			>
				Neue Berichtsjahre
			</button>

		</div>

		<div>

			@if( bLoading ) {
				<!-- there is already a spinner higher -->
			}
			@else if( !elements.length ) {
				<div class="accNoElements">
					Keine Berichtsjahre vorhanden
				</div>
			}
			@else {

				<div class="accFilterAndAccordeon">

					<mat-form-field
						appearance="outline"
						subscriptSizing="dynamic"
						class="accFilter"
					>

						<mat-label>Filter</mat-label>
						<input
							matInput
							placeholder="Beispiel: Jahr1990"
							(keyup)="onFilterChanged($event)"
						>
						<mat-icon matSuffix>search</mat-icon>

					</mat-form-field>

					<div
						class="accAccordeon"
						[style.--nbColumns]="'6'"
					>
	
						@if( !filteredElements.length ) {
	
							<div class="accNoElements">
								Keine Daten entspricht dem Filter
							</div>
	
						}	
						@else {

							<div
								class="accHeaders"
								[class.accSortIconDesc]="!sortingAsc"
							>

								<div
									class="accCell"
									[class.accActiveSorting]="sortingField == 'bjJahr'"
									(click)="sortColumn('bjJahr')"
									title="Nach Jahre sortieren"
								>
									<div class="accHeader">
										<span>Jahre</span>
										<mat-icon class="accSortIcon">
											{{ sortingField == 'bjJahr' ? 'arrow_downward' : 'swap_vert' }}
										</mat-icon>
									</div>
								</div>

								<div
									class="accCell"
									[class.accActiveSorting]="sortingField == 'bjVon'"
									(click)="sortColumn('bjVon')"
									title="Nach Von sortieren"
								>
									<div class="accHeader">
										<span>von</span>
										<mat-icon class="accSortIcon">
											{{ sortingField == 'bjVon' ? 'arrow_downward' : 'swap_vert' }}
										</mat-icon>
									</div>
								</div>

								<div
									class="accCell"
									[class.accActiveSorting]="sortingField == 'bjBis'"
									(click)="sortColumn('bjBis')"
									title="Nach Bis sortieren"
								>
									<div class="accHeader">
										<span>bis</span>
										<mat-icon class="accSortIcon">
											{{ sortingField == 'bjBis' ? 'arrow_downward' : 'swap_vert' }}
										</mat-icon>
									</div>
								</div>

								<div
									class="accCell"
									[class.accActiveSorting]="sortingField == 'bjAnpassungsfaktorVGV'"
									(click)="sortColumn('bjAnpassungsfaktorVGV')"
									title="Nach Faktor VGV sortieren"
								>
									<div class="accHeader">
										<span>Faktor VGV</span>
										<mat-icon class="accSortIcon">
											{{ sortingField == 'bjAnpassungsfaktorVGV' ? 'arrow_downward' : 'swap_vert' }}
										</mat-icon>
									</div>
								</div>

								<div
									class="accCell"
									[class.accActiveSorting]="sortingField == 'bjFreigabe'"
									(click)="sortColumn('bjFreigabe')"
									title="Nach Erfassungsfreigabe sortieren"
								>
									<div class="accHeader">
										<span>Erfassungsfreigabe</span>
										<mat-icon class="accSortIcon">
											{{ sortingField == 'bjFreigabe' ? 'arrow_downward' : 'swap_vert' }}
										</mat-icon>
									</div>
								</div>

								<div
									class="accCell"
									[class.accActiveSorting]="sortingField == 'bjSichtbar'"
									(click)="sortColumn('bjSichtbar')"
									title="Nach Statistikfreigabe sortieren"
								>
									<div class="accHeader">
										<span>Statistikfreigabe</span>
										<mat-icon class="accSortIcon">
											{{ sortingField == 'bjSichtbar' ? 'arrow_downward' : 'swap_vert' }}
										</mat-icon>
									</div>
								</div>

							</div>
								
							<div class="accScrollPanel">
	
								@for( element of filteredElements; track element.bjJahr ) {
	
									<div
										class="accRow"
										(click)="clickOnRow( element.bjJahr )"
										[class.accRowActive]="expandedElementId == element.bjJahr"
										[id]="'elementRow_' + element.bjJahr"
									>

										<div class="accCell">
											{{ element.bjJahr }}
										</div>
										<div class="accCell">
											{{ element.bjVon | date }}
										</div>
										<div class="accCell">
											{{ element.bjBis | date }}
										</div>
										<div class="accCell">
											{{ element.bjAnpassungsfaktorVGV | number:'1.2' }}
										</div>
										<div class="accCell">
											{{ element.bjFreigabe ? 'ja' : 'nein' }}
										</div>
										<div class="accCell">
											{{ element.bjSichtbar ? 'ja' : 'nein'}}
										</div>

									</div>
	
									@if( expandedElementId == element.bjJahr ) {
	
										<div
											class="accDetail"
											[@accordeonMe]
										>
											<app-year-editor 
												[element]="element"
												(done)="sortElements()"
											/>
										</div>
	
									}
	
								}
	
							</div>
	
						}
	
					</div>

				</div>

			}

		</div>

	</div>

</div>
